import api from '../../api/nodeBackApi';

export const settingCamaraAndStockThroughWizard = async (camaraIdentifier, camaraData) => {
    try {
        const response = await api.post(`/api/camara/settingCamaraAndStockThroughWizard/${camaraIdentifier}`, camaraData);
        return response.data;
    } catch (error) {
        console.error("Error setting up camara through wizard:", error);
        throw error;
    }
}